import React from "react";
import ConfirmationModal from "./modalWindow/confirmationModal";
import MessageOkModal from "./modalWindow/messageOkModal";

function ModalFactory(props) {
    if (props.modalMode === "modalYesNo") {
      return (
        <ConfirmationModal
          open={props.show}
          title={props.title}
          children={props.paragraph}
          button1Title={props.buttonSaveText}
          onConfirm={props.onClickSave}
          button2Title={props.buttonCancelText}
          onCancel={props.onClickCancel}
        />
      );
    }
    if (props.modalMode === "modalOk") {
      return (
        <MessageOkModal
          open={props.show}
          title={props.title}
          children={props.paragraph}
          button1Title={props.buttonOk}
          onConfirm={props.onClickOk}
        />
      );
    }
}
export default ModalFactory;